import {Button, Radio} from "antd";
import React, {useEffect, useState} from "react";
import {ListItems} from "../../../../CRUD/ListItems";
import {GetItem} from "../../../../CRUD/GetItem";
import {MapLayerService} from "../../../../../service/mapLayerService";
import {HandleRemove} from "../utils/HandleRemove";
import {MenuOutlined} from "@ant-design/icons";
import i18next from "i18next";
import {sortableHandle} from "react-sortable-hoc";
import {HandleAdd} from "../utils/HandleAdd";
import SortTable from "../utils/SortTable";

const MapLayersInMapTable = ({editMapConfig, setEditMapConfig, deleteLayers, setDeleteLayers, addLayers, setAddLayers, layers, setLayers}) => {

    const [allLayers, setAllLayers] = useState()//for all layers from backend
    const [selectedValue, setSelectedValue] = useState()//hook for selected value
    const [selectedLayer, setSelectedLayer] = useState()//hook for selected layer
    const [order, setOrder] = useState()//order field hook
    const [layersToSelect, setLayersToSelect] = useState([])//layers the user can select from dropdown

    const [randomNum, setRandomNum] = useState(generateRandomNumber());

    function generateRandomNumber() {
        const min = 30;
        const max = 100;
        const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        return randomNumber;
    }

    const listAllLayers = () => {
        ListItems(allLayers, setAllLayers, MapLayerService.getAllLayers)
    }

    const getSelectedLayer = (id) => {
        GetItem(selectedLayer, setSelectedLayer, MapLayerService.getLayer, id)
    }

    let allLayerstransform = []//for transforming all layers into a usable array with values

    let mapLayersTransrofm = []//for transforming current maplayers into a usable array with values

    let availableLayers = []//alllayerstransform - maplayersTransrofm

    let mapLayersTranformsSort = []

    //load all layers
    useEffect(() => {
        listAllLayers()
    }, [])

    //set available layers if alllayers is changed
    useEffect(() => {

        if (allLayers != undefined) {
            for (let i = 0; i < allLayers.length; i++) {
                allLayerstransform[i] = {
                    value: allLayers[i].idMapLayer,
                    label: allLayers[i].name,
                }
            }
        }

        if (editMapConfig.map.mapMaplyrList != undefined) {
            for (let i = 0; i < editMapConfig.map.mapMaplyrList.length; i++) {
                mapLayersTransrofm[i] = {
                    value: editMapConfig.map.mapMaplyrList[i].mapLayer.idMapLayer,
                    label: editMapConfig.map.mapMaplyrList[i].mapLayer.name,
                }
            }
        }

        if (editMapConfig.map.mapMaplyrList != undefined) {
            for (let i = 0; i < editMapConfig.map.mapMaplyrList.length; i++) {
                mapLayersTranformsSort[i] = {
                    conf: editMapConfig.map.mapMaplyrList[i].mapLayer.conf,
                    idMapLayer: editMapConfig.map.mapMaplyrList[i].mapLayer.idMapLayer,
                    description: editMapConfig.map.mapMaplyrList[i].mapLayer.description,
                    type: editMapConfig.map.mapMaplyrList[i].mapLayer.type,
                    name: editMapConfig.map.mapMaplyrList[i].mapLayer.name,
                    idMapConf: editMapConfig.map.mapMaplyrList[i].sgvmapMapcnfMaplyrPK.idMapConf,
                    order: editMapConfig.map.mapMaplyrList[i].sgvmapMapcnfMaplyrPK.order,
                    index: editMapConfig.map.mapMaplyrList[i].sgvmapMapcnfMaplyrPK.order
                }
            }
        }

        setLayers(mapLayersTranformsSort)
        availableLayers = allLayerstransform.filter(a => !mapLayersTransrofm.map(b => b.value).includes(a.value));
        setLayersToSelect(availableLayers)
    }, [allLayers])

    let toDeleteLayersList = []

    let toAddLayersList = []

    const renderSelected = (value) => {
        getSelectedLayer(value)
        setSelectedValue(value)
    }

    const handleRemove = (mapLayer) => {

        //console.log(mapLayer)
        let mapId, layerId, layerName

        if (mapLayer.sgvmapMapcnfMaplyrPK != undefined) {
            mapId = mapLayer.sgvmapMapcnfMaplyrPK.idMapConf
            layerId = mapLayer.mapLayer.idMapLayer
            layerName = mapLayer.mapLayer.name
        } else if (mapLayer.joinTable != undefined) {
            mapId = mapLayer.joinTable.idMapConf
            layerId = mapLayer.mapToolOrLayer.idMapLayer
            layerName = mapLayer.mapToolOrLayer.name
        } else if (mapLayer.index != undefined) {
            mapId = editMapConfig.map.idMapConf
            layerId = mapLayer.idMapLayer
            layerName = mapLayer.name
        }

        HandleRemove(mapLayer, layers, setLayers, toDeleteLayersList, deleteLayers, setDeleteLayers,
            mapId, layerId, layerName, availableLayers, layersToSelect, setLayersToSelect,
            setSelectedValue, setOrder, setSelectedLayer)

    }

    const handleAdd = () => {

        let joinTable = {
            idMapConf: editMapConfig.map.idMapConf,
            idMapToolOrLayer: selectedLayer.idMapLayer,
            order: parseInt(randomNum)
        };
        let item = {

            conf: selectedLayer.conf,
            idMapLayer: selectedLayer.idMapLayer,
            name: selectedLayer.name,
            description: selectedLayer.description,
            order: parseInt(randomNum),
            index: parseInt(randomNum)

        };

        setRandomNum(generateRandomNumber())

        HandleAdd(joinTable, item, setOrder, setSelectedLayer,
            toAddLayersList, addLayers, setAddLayers, availableLayers, setLayers,
            selectedValue, setSelectedValue, layersToSelect, setLayersToSelect)

    }

    const [selectedItems, setSelectedItems] = useState([]);

    const getColumns = () => {

        return [
            {
                title: i18next.t('common.tools.edit.sort'),
                dataIndex: "",
                width: '15%',
                className: "drag-visible",
                render: (d, dd, i) => (
                    <>
                        <DragHandle active={selectedItems.includes(i)}/>
                    </>
                )
            },
            {
                title: i18next.t('common.tools.edit.layer_name'),
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: i18next.t('common.tools.edit.description'),
                key: 'description',
                dataIndex: 'description',
            },
            {
                title: i18next.t('common.tools.edit.action'),
                key: 'action',
                render: (mapLayer) =>
                    <Radio.Group>
                        <Button danger onClick={() => {
                            handleRemove(mapLayer)
                        }} type="primary" id="layerDeleteButton">{i18next.t('common.tools.edit.delete')} </Button>
                    </Radio.Group>
            },
        ]
    };

    const DragHandle = sortableHandle(({active}) => (
        <MenuOutlined style={{cursor: "grab", color: active ? "blue" : "#999"}}/>
    ));

    return (
        <>
            <SortTable selectedItems={selectedItems} setSelectedItems={setSelectedItems}
                       items={layers} setItems={setLayers} itemsToSelect={layersToSelect}
                       renderSelected={renderSelected} order={order} setOrder={setOrder}
                       handleAdd={handleAdd} getColumns={getColumns} selectedValue={selectedValue} type="Layer"/>
        </>
    )
}
export default MapLayersInMapTable;